module.exports = __webpack_public_path__ + "img/202509-2_08.1417c466.jpg";